import { render, staticRenderFns } from "./PlanMovil.vue?vue&type=template&id=ff42396e&scoped=true"
import script from "./PlanMovil.vue?vue&type=script&lang=js"
export * from "./PlanMovil.vue?vue&type=script&lang=js"
import style0 from "./PlanMovil.vue?vue&type=style&index=0&id=ff42396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff42396e",
  null
  
)

export default component.exports